import { sendNativeRequest, type ChartTradeInteractionMessage } from './bridge';

/**
 * 차트 기반 TP/SL & 포지션 관리(ERD-234)의 web→native 인터랙션 메시지 빌더/전송.
 *
 * 모바일 webview에서 web은 모달을 직접 띄우지 않고, 드래그/탭 제스처가 끝나면 이 메시지를
 * native로 보내 확인 UI 표시·실행을 위임한다. (데스크톱 web은 기존 모달 경로 유지)
 *
 * ⚠️ 메시지 wire 포맷·callback 이름은 ERD 컨트랙트를 기존 simple-bridge 패턴에 맞춰 *가정* 한
 * 것이다. 모바일 엔지니어와 추후 반드시 합의해야 한다. (docs/chart-based-tpsl-drag-adjustment.md 11절)
 */

export type ChartTradeInteractionType = ChartTradeInteractionMessage['params']['type'];

export interface ChartTradeInteractionInput {
  type: ChartTradeInteractionType;
  symbol: string;
  slot: number;
  /** *_TPSL 용. */
  lineType?: 'TP' | 'SL';
  /** MODIFY/DELETE 용 — 기존 조건부 주문 id. */
  orderId?: string;
  /** CREATE/MODIFY — 제스처 종료 시 라인 가격(web이 tick 정렬). */
  triggerPrice?: string;
}

/** 입력을 simple-bridge `chartTradeInteraction` 메시지로 변환한다. 해당 없는 필드는 생략. */
export function buildChartTradeInteractionMessage(input: ChartTradeInteractionInput): ChartTradeInteractionMessage {
  const params: ChartTradeInteractionMessage['params'] = {
    type: input.type,
    symbol: input.symbol,
    slot: input.slot,
  };
  if (input.lineType !== undefined) params.lineType = input.lineType;
  if (input.orderId !== undefined) params.orderId = input.orderId;
  if (input.triggerPrice !== undefined) params.triggerPrice = input.triggerPrice;

  return {
    name: 'chartTradeInteraction',
    callback: 'onChartTradeInteractionResult',
    params,
  };
}

/** native로 `chartTradeInteraction` 메시지를 전송한다 (기존 simple-bridge 재사용). */
export function sendChartTradeInteraction(input: ChartTradeInteractionInput): void {
  sendNativeRequest(buildChartTradeInteractionMessage(input));
}
